export const getActiveTab = state => state.ui.activeTab;
